import api from "@/api";
import { AxiosResponse } from "axios";

export interface HeldSeatsResponse {
  /** Ids of the seats the user holds on the event. */
  seats: string[];
  /** When the holds end, null when none is left. */
  expires_at: string | null;
}

/** The seats the user holds on the event, without renewing them. */
export default async function getHeldSeats(eventId: string): Promise<HeldSeatsResponse> {
  const response: AxiosResponse<HeldSeatsResponse> = await api.get(`/api/events/${eventId}/reservation/seats`);
  return response.data;
}
